export default "__VITE_ASSET__53dd1ac0__"